import axios from '@/store/config';
import { orderBy } from 'lodash';
import dayjs from 'dayjs';
import { OFFER_RESPONSE_CODES, RENTALOBJECT_TYPE_CODES } from '@/config/constants';

export default {

  // state
  state : {
    offers: [],
  },

  // getters
  getters : {

    offers: (state) => state.offers,

    currentOffers: (state) => {
      return orderBy(state.offers.filter(offer => offer.status == 'G'), ['_objectType', '_responseOrderCode'], ['asc', 'desc']);
    },

    oldOffers: (state) => {
      //return orderBy(state.offers.filter(offer => offer.status == 'A'), ['_objectType','lastReplyDate'], ['asc', 'desc']);

      return orderBy(state.offers.filter(offer => offer.status == 'A'), ['lastReplyDate'], ['desc']);
    },

    /**
     * Hämtar offer på offerNUmber (motsvarar id)
     *
     * Utgår ifrån att offers har hämtats innan
     */
    getOfferByOfferNumber: (state) => (offerNumber) => {
      return state.offers.find(offer => offer.offerNumber === offerNumber)
    },

    /**
     * Skicka in ett rentalObjectCode å tar reda på om det tillhör ett erbjudande.
     */
    isRentalObjectCodeOffer: (state) => (rentalObjectCode) => {
      return state.offers.some(offer => offer.rentalObjectCode == rentalObjectCode)
    },

    /**
     * Skicka in ett rentalObjectCode å tar reda på om det tillhör ett aktuellt erbjudande.
     */
    isRentalObjectCodeCurrentOffer: (state) => (rentalObjectCode) => {
      return state.offers.some(offer => offer.rentalObjectCode == rentalObjectCode && offer.status == 'G')
    }
  },

  // actions
  actions : {
    fetchOffers ({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('/Applicants/me/offers')
        .then((response) => {
          commit('setOffers', response.data);
          return resolve(response.data);
        })
        .catch((error) => {
          return reject(error); // skickar vidare
        });
      });
    },

    postOfferAnswer({state, dispatch}, payload){
        return new Promise((resolve, reject) => {
          axios.post('/offers/'+payload.id+'/answer', { answerIsYes: payload.answerIsYes, comment: '' })
          .then((response, commit) => {
            resolve();
            return dispatch('fetchOffers');
          })
          .catch((error) => {
            reject(error); // skickar vidare
          });

        });

    }
  },


  // mutations
  mutations : {
    setOffers (state, offers) {
      // vissa fält behövs för sortering
      offers.forEach((offer) => {
        offer._objectType = offer.rentalObject.objectType;
        offer._lastReplyDatePast = dayjs(offer.lastReplyDate).isBefore();

        if(offer._lastReplyDatePast){
          offer._responseOrderCode = 0;
        } else if( offer.responseCode === OFFER_RESPONSE_CODES.YES) {
          offer._responseOrderCode = 1;
        } else if( offer.responseCode == OFFER_RESPONSE_CODES.NO_ANSWER_YET || OFFER_RESPONSE_CODES.EMPTY_ANSWER_CODE ) {
          offer._responseOrderCode = 2;
        } else if( offer.responseCode == OFFER_RESPONSE_CODES.NO || offer.rentalObjectTypeCode == RENTALOBJECT_TYPE_CODES.STUDENTBOSTAD) { // LGH20 = Studentlägenhet
          offer._responseOrderCode = 3;
        }
      })

      state.offers = offers;
    },
    // setCurrentOffers (state, offers) {
    //   state.currentOffers = offers;
    // },
    // setOldOffers (state, offers) {
    //   state.oldOffers = offers;
    // }
  }

}
